import React from 'react'
import { IconButton, Tooltip } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import "./stardew_modpack.css"

const StardewModpack = () => {
    return <div className="geometric page" style={{height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <Tooltip title="home" placement="right" style={{position: "absolute", left: "0", top: "0"}}>
            <IconButton href="/" aria-label="home" size="large" className="home-button"><HomeIcon /></IconButton>
        </Tooltip>

        <div className="glyph secondary" style={{fontSize: "3rem", textAlign: "center", marginTop: "2rem", position: "absolute", top: "0vh"}}>
            stardew valley modpack
        </div>
        
        <a href="https://github.com/ZachNobles/Farmers-Government-Certified-Modpack/releases/download/Main/Farmers.Government.Certified.Modpack.v1.0.zip" target="_blank" rel="noopener noreferrer"
        className="no-link-styling glyph" id="stardew-modpack-download-button"
        style={{width: "30vw", height: "10vh", border: "2px solid var(--accent)", borderRadius: "1rem", display: "grid", placeItems: "center", fontSize: "1.5rem", transition: "0.2s", textAlign: "center", boxShadow: "inset 0 0 10px var(--accent)"}}
        >
            Farmers' Government Certified Modpack v1.0
        </a>

        <div className="glyph" style={{fontSize: "1.5rem", textAlign: "center", marginTop: "2rem"}}>
            current mods
        </div>

        <div className="geometric" style={{fontSize: "1.25rem", textAlign: "center", marginTop: "2rem", columnCount: 2}}>
            Automate<br/>
            Automatic Gates<br/>
            Better Crafting<br/>
            Bigger Fridges<br/>
            Bird Cove<br/>
            Button's Extra Books<br/>
            Chests Anywhere<br/>
            Frontier Farm<br/>
            Grampleton Fields<br/>
            Lookup anything<br/>
            Northwest Coast<br/>
            Ridgeside Village<br/>
            Secret Woods Extra Area<br/>
            Simple Crop Label<br/>
            Stardew Valley Expanded<br/>
            Tractor<br/>
            Visible Fish<br/>
        </div>
    </div>;
}

export default StardewModpack;